"use strict";
import { SET_TOOL_TOC_OPEN } from "./types";

export function setToolTOCOpen(open) {
  return {
    type: SET_TOOL_TOC_OPEN,
    payload: open,
  };
}
